import { css } from 'buttered';
import { useMemo } from 'react';

export let useCss = (styles: string | buttered.CSSAttribute, deps?: any[]) => {
  let usedDeps = deps ? deps : [styles];

  return useMemo(() => css(styles), usedDeps);
};
